import type { RequestTypeResponse } from '../../services/fetch-request-type/types';
import type { RequestTypesResponse, RequestTypeOption } from './types';

export const toRequestTypeOption = (
	requestType: RequestTypeResponse | RequestTypesResponse['values'][number],
): RequestTypeOption => ({
	id: requestType.id,
	name: requestType.name,
	iconUrl: requestType?.icon?._links?.iconUrls?.['24x24'],
});
